import React from 'react';
import { BackgroundIcon } from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Link, withRouter } from 'react-router-dom';
import { Button } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
// import TabContext from '@nile/mangifera/src/Contexts/TicketContext';

const getThemeClassNames = {
  default: '',
  primary: 'white-bg bshadow'
};

function AccordionItem(props) {
  const style = {
    collapsed: {
      display: 'none'
    },
    expanded: {
      display: 'block'
    },
    buttonStyle: {
      display: 'block',
      width: '100%'
    }
  };

  return (
    <div
      className={`accordion-transition ${
        props.isCollapsed ? 'hide-accordion-item' : 'show-accordion-item'
      } ${getThemeClassNames[props.theme]} ${props.customClassItemWrapper}`}
    >
      <div
        style={style.buttonStyle}
        onClick={() => props.handleClick()}
        className={`pt16 pb16`}
      >
        <div className="fx actr p15 pd-y0 ptr">
          {props.icon && (
            <div className="header-icon">
              <BackgroundIcon url={props.icon} width="40px" height="40px" />
            </div>
          )}
          <div className="header-text">
            <p className="accordion-head accordion-transition">{props.label}</p>
          </div>
          {props.linkOnClick && (
            <div className="mr-10 ml-10 no-flex-text-shrink">
              <Button
                plain
                onClick={() => {
                  props.linkOnClick();
                }}
              >
                {props.linkText}
              </Button>
            </div>
          )}
          <div className="accordion-idicator accordion-transition">
            <div className="fx center">
              <SVGIcon name="ArrowRight" size="lg" />
            </div>
          </div>
        </div>
      </div>
      <div
        className="collapse-content"
        style={props.isCollapsed ? style.collapsed : style.expanded}
        aria-expanded={props.isCollapsed}
      >
        {!props.isCollapsed && props.children}
      </div>
    </div>
  );
}

export default withRouter(AccordionItem);
